import { render, staticRenderFns } from "./JobReferralCard.vue?vue&type=template&id=35eb89c0&"
import script from "./JobReferralCard.vue?vue&type=script&lang=ts&"
export * from "./JobReferralCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports